import React, { useState } from "react";
import { User, BookOpen, CreditCard, Download, Video, Award, Menu, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import imgdatascience2 from "../assets/datascience2.png";

export default function DashboardPage() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <div className="min-h-screen flex bg-gray-100 text-gray-800">
      {/* Sidebar */}
     {sidebarOpen && (
        <aside className="w-64 bg-white p-6 shadow-lg space-y-6 relative">
          <button
            onClick={() => setSidebarOpen(false)}
            className="absolute top-4 right-4 text-gray-500 hover:text-green-700"
          >
            ×
          </button>
          <h2 className="text-xl font-bold text-green-700">Dashboard</h2>
          <nav className="space-y-4">
            <a href="#profil" className="flex items-center gap-3 text-gray-700 hover:text-green-600">
              <User size={18} /> Profil Peserta
            </a>
            <a href="#status" className="flex items-center gap-3 text-gray-700 hover:text-green-600">
              <BookOpen size={18} /> Status Kelas
            </a>
            <a href="#riwayat-kelas" className="flex items-center gap-3 text-gray-700 hover:text-green-600">
              <Video size={18} /> Riwayat Kelas
            </a>
            <a href="#riwayat-pembayaran" className="flex items-center gap-3 text-gray-700 hover:text-green-600">
              <CreditCard size={18} /> Riwayat Pembayaran
            </a>
            <a href="#sertifikat" className="flex items-center gap-3 text-gray-700 hover:text-green-600">
              <Award size={18} /> Sertifikat
            </a>
            <a href="#materi" className="flex items-center gap-3 text-gray-700 hover:text-green-600">
              <Download size={18} /> Materi & Rekaman
            </a>
            <button
              onClick={handleLogout}
              className="flex items-center gap-3 text-red-600 hover:text-red-800 mt-6"
            >
              <LogOut size={18} /> Keluar
            </button>
          </nav>
        </aside>
      )}

      {/* Content */}
      <main className="flex-1 p-8 space-y-10">
      {!sidebarOpen && (
          <button
            onClick={() => setSidebarOpen(true)}
            className="mb-4 text-gray-600 hover:text-green-700 flex items-center gap-2"
          >
            <Menu size={20} /> Menu
          </button>
        )}
        <section id="profil">
          <h2 className="text-2xl font-semibold mb-4 text-green-700">Profil Peserta</h2>
          <div className="bg-white p-6 rounded-xl shadow">
            <p><strong>Nama:</strong> Kent Antonio Bintoro</p>
            <p><strong>Email:</strong> kentbintoro@gmail.com</p>
            <p><strong>Status:</strong> Peserta Aktif</p>
          </div>
        </section>

        <section id="status">
          <h2 className="text-2xl font-semibold mb-4 text-green-700">Status Kelas</h2>
          <div className="bg-white p-6 rounded-xl shadow">
            <p><strong>Jenis Kelas:</strong> Premium Class - Data</p>
            <p><strong>Jadwal:</strong> Sabtu, 13.00 - 14.30 WIB</p>
            <p><strong>Status:</strong> <span className="text-green-600 font-semibold">Aktif</span></p>
          </div>
        </section>

        <section id="riwayat-kelas">
          <h2 className="text-2xl font-semibold mb-4 text-green-700">Riwayat Kelas</h2>
          <div className="bg-white p-6 rounded-xl shadow">
          <h3 className="font-bold">Batch 1 - Data</h3>
            <ul className="list-disc list-inside space-y-1">
              <li>Materi 1: Pengenalan Data Analytics</li>
              <li>Materi 2: Jenis Data dan Tools Dasar</li>
              <li>Materi 3: Pengolahan Data Dasar</li>
              <li>Materi 4: Exploratory Data Analytic </li>
              <li>Materi 5: Join & Union 101 (Seni Menggabungkan Data)</li>
              <li>Materi 6: Visualisasi Data Menggunakan Looker Studio</li>
            </ul>

            <br />

            <h3 className="font-bold">Batch 2 - Data</h3>
            <ul className="list-disc list-inside space-y-1">
              <li>Materi 1: SQL Basic : Fondasi Bahasa Data</li>
              <li>Materi 2: SQL CRUD di Google Bigquery : Simulasi Manipulasi Data</li>
              <li>Materi 3: Deep Dive BigQuery</li>
              <li>Materi 4: Exploratory Data Analytic</li>
              <li>Materi 5: Exploratory Data Analytic 2</li>
              <li>Materi 6: Data Storytelling</li>
            </ul>

          </div>
        </section>

        <section id="riwayat-pembayaran">
          <h2 className="text-2xl font-semibold mb-4 text-green-700">Riwayat Pembayaran</h2>
          <div className="bg-white p-6 rounded-xl shadow">
            <ul className="space-y-2">
              <li><strong>30 Mei 2025</strong> - Premium Class - Rp950.000 ✅</li>
              <li><strong>7 Maret 2025</strong> - Premium Class - Rp950.000 ✅</li>
            </ul>
          </div>
        </section>

        <section id="sertifikat">
          <h2 className="text-2xl font-semibold mb-4 text-green-700">Sertifikat</h2>
          <div className="bg-white p-6 rounded-xl shadow">
            <p>Anda telah menyelesaikan Premium Data Class #1</p>
            <a target="_blank" rel="noreferrer"
              href="https://drive.google.com/file/d/1wjYoSJSPMNLaNR6irdM1bvdwKypKJa_C/view?usp=sharing"
              className="inline-block mt-2 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
              download
            >
              Unduh Sertifikat
            </a>
            <br /> <br />
            <p>Anda telah menyelesaikan Premium Data Class #2</p>
            <a target="_blank" rel="noreferrer"
              href="https://drive.google.com/file/d/1T3nEhMfSCpbE5BxXLiMMhn6N0Fgwculy/view?usp=sharing"
              className="inline-block mt-2 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
              download
            >
              Unduh Sertifikat
            </a>
          </div>
        </section>

        <section id="materi">
          <h2 className="text-2xl font-semibold mb-4 text-green-700">Materi & Rekaman</h2>
          <div className="bg-white p-6 rounded-xl shadow space-y-2">
          <h3 className="font-bold">Batch 1 - Data</h3>
            <ul className="list-disc list-inside space-y-1">
              <li>Materi 1: Pengenalan Data Analytics - <a href="https://www.youtube.com/watch?v=eysIzsUUlmg&list=PLnEwMB_93IPOIcx5vdtbF5fjnQbFxqAKC&index=6&pp=gAQBiAQB" className="text-blue-600 underline">Tonton Ulang</a>  - <a href="https://kursus-coding-online.my.canva.site/dataclass-1-pengenalan-data-analytics" className="text-blue-600 underline"  target="_blank" rel="noreferrer">Download Materi</a> </li>
              <li>Materi 2: Jenis Data dan Tools Dasar - <a href="https://www.youtube.com/watch?v=CkLpFOjzYZU&list=PLnEwMB_93IPOIcx5vdtbF5fjnQbFxqAKC&index=5&pp=gAQBiAQB" className="text-blue-600 underline">Tonton Ulang</a> - <a href="https://kursus-coding-online.my.canva.site/dataclass-2-pengenalan-jenis-data-dan-tools-dasar" className="text-blue-600 underline"  target="_blank" rel="noreferrer">Download Materi</a> </li>
              <li>Materi 3: Pengolahan Data Dasar - <a href="https://www.youtube.com/watch?v=5LyI2vALanM&list=PLnEwMB_93IPOIcx5vdtbF5fjnQbFxqAKC&index=4&pp=gAQBiAQB" className="text-blue-600 underline">Tonton Ulang</a> - <a href="https://kursus-coding-online.my.canva.site/dataclass-3-pengolahan-data-dasar" className="text-blue-600 underline"  target="_blank" rel="noreferrer">Download Materi</a> </li>
              <li>Materi 4: Exploratory Data Analytic - <a href="https://www.youtube.com/watch?v=lrD1rgoK3Dw&list=PLnEwMB_93IPOIcx5vdtbF5fjnQbFxqAKC&index=3&pp=gAQBiAQB" className="text-blue-600 underline">Tonton Ulang</a> - <a href="https://kursus-coding-online.my.canva.site/dataclass-4-exploratory-data-analysis" className="text-blue-600 underline"  target="_blank" rel="noreferrer">Download Materi</a> </li>
              <li>Materi 5: Join & Union 101 (Seni Menggabungkan Data) - <a href="https://www.youtube.com/watch?v=CIC8cJvFCDg&list=PLnEwMB_93IPOIcx5vdtbF5fjnQbFxqAKC&index=2&pp=gAQBiAQB" className="text-blue-600 underline">Tonton Ulang</a> - <a href="https://kursus-coding-online.my.canva.site/dataclass-5-join-union-101-seni-menggabungkan-data" className="text-blue-600 underline"  target="_blank" rel="noreferrer">Download Materi</a> </li>
              <li>Materi 6: Visualisasi Data Menggunakan Looker Studio - <a href="https://www.youtube.com/watch?v=MGpbehzv9Ec&list=PLnEwMB_93IPOIcx5vdtbF5fjnQbFxqAKC&index=1&pp=gAQBiAQB0gcJCa0JAYcqIYzv" className="text-blue-600 underline">Tonton Ulang</a> - <a href="https://kursus-coding-online.my.canva.site/dataclass-6-visualisasi-data-menggunakan-looker-studio" className="text-blue-600 underline"  target="_blank" rel="noreferrer">Download Materi</a> </li>
            </ul>

            <br />

            <h3 className="font-bold">Batch 2 - Data</h3>
            <ul className="list-disc list-inside space-y-1">
              <li>Materi 1: SQL Basic : Fondasi Bahasa Data - <a href="https://www.youtube.com/watch?v=Jo7egtFRD0Q&list=PLnEwMB_93IPOEO2w5sChTE2kA7PIoz5mg&index=3" className="text-blue-600 underline">Tonton Ulang</a> - <a href="https://materi-1-web-dasar-kco.my.canva.site/sql-basic-fondasi-bahasa-data" className="text-blue-600 underline"  target="_blank" rel="noreferrer">Download Materi</a> </li>
              <li>Materi 2: SQL CRUD di Google Bigquery : Simulasi Manipulasi Data - <a href="https://www.youtube.com/watch?v=BwIRwC7e9hw&list=PLnEwMB_93IPOEO2w5sChTE2kA7PIoz5mg&index=4" className="text-blue-600 underline">Tonton Ulang</a> - <a href="https://materi-1-web-dasar-kco.my.canva.site/salinan-dari-02b2-sql-crud-bigquery" className="text-blue-600 underline"  target="_blank" rel="noreferrer">Download Materi</a> </li>
              <li>Materi 3: Deep Dive BigQuery - SQL Relasional: JOIN, CTE, dan Validasi Integritas - <a href="https://www.youtube.com/watch?v=nyiVju9E44c&list=PLnEwMB_93IPOEO2w5sChTE2kA7PIoz5mg&index=2&pp=gAQBiAQB0gcJCa0JAYcqIYzv" className="text-blue-600 underline">Tonton Ulang</a> - <a href="https://drive.google.com/file/d/1GY_ZO1AnO7rzPcAFjOVrlVyhXY8XbQqI/view?usp=sharing" className="text-blue-600 underline"  target="_blank" rel="noreferrer">Download Materi</a> </li>
              <li>Materi 4: Exploratory Data Analytic - <a href="https://www.youtube.com/watch?v=hkYMVa4QcTk&list=PLnEwMB_93IPOEO2w5sChTE2kA7PIoz5mg&index=1" className="text-blue-600 underline">Tonton Ulang</a> - <a href="https://drive.google.com/file/d/1U0Xs7Am-QnjS2AGUMT_fcY4U8Jc-yNCg/view?usp=sharing" className="text-blue-600 underline"  target="_blank" rel="noreferrer">Download Materi</a> </li>
              <li>Materi 5: Exploratory Data Analytic 2 - <a href="https://www.youtube.com/watch?v=xB6xBukX_0s&list=PLnEwMB_93IPOEO2w5sChTE2kA7PIoz5mg&index=5&pp=gAQBiAQB" className="text-blue-600 underline">Tonton Ulang</a> - <a href="https://drive.google.com/file/d/1U0Xs7Am-QnjS2AGUMT_fcY4U8Jc-yNCg/view?usp=sharing" className="text-blue-600 underline"  target="_blank" rel="noreferrer">Download Materi</a> </li>
              <li>Materi 6: Data Storytelling - <a href="https://www.youtube.com/watch?v=IqlJyFbXHE8&list=PLnEwMB_93IPOEO2w5sChTE2kA7PIoz5mg&index=6&pp=gAQBiAQB" className="text-blue-600 underline">Tonton Ulang</a> - <a href="https://drive.google.com/file/d/11Mjo9dUbz6t-36FHJ6AagWQyGC3WNcu0/view?usp=sharing" className="text-blue-600 underline"  target="_blank" rel="noreferrer">Download Materi</a> </li>
            </ul>

          </div>
        </section>

        <section id="badge">
          <h2 className="text-2xl font-semibold mb-4 text-green-700">Badge & Pencapaian</h2>
          <div className="bg-white p-6 rounded-xl shadow flex gap-4 flex-wrap">
            <div className="bg-green-100 text-green-800 px-4 py-2 rounded-full">Data Mastery</div>
            <div className="bg-yellow-100 text-yellow-800 px-4 py-2 rounded-full">Kehadiran 100%</div>
            <div className="bg-blue-100 text-blue-800 px-4 py-2 rounded-full">Top Learner</div>
          </div>
        </section>

        <section id="Recommendation">
          <h2 className="text-2xl font-semibold mb-4 text-green-700">Rekomendasi Kelas Selanjutnya</h2>
          <div className="bg-white p-6 w-1/3 rounded-xl shadow flex gap-4 flex-wrap">
          <img
                      src={imgdatascience2}
                      className="rounded-lg h-40 w-full object-cover mb-4"
                    />
                    <center>
                    Data Science Class
                    </center> 
          </div>
        </section>
      </main>
    </div>
  );
}
